import { calculateTTCFromUser } from "lib/shared/compensation/calculateTTCFromUser";
import { annualizeCashValue } from "lib/shared/compensation/cash";
import { EmploymentSubType } from "lib/shared/compensation/employment/types";
import { Company, User } from "prisma/cm/client";

export const calculateOTEFromUser = (
  user: User,
  company?: Company,
  includeBonusTarget = true,
): number => {
  if (includeBonusTarget) return calculateTTCFromUser(user, company);

  const base = user.salary ?? 0;

  const baseAnnualized = annualizeCashValue({
    value: base,
    incomeFrequency: user.salaryIncomeFrequency,
    employmentSubType: user.employmentSubType as EmploymentSubType,
    weeklyWorkingHours: company?.weeklyWorkingHours,
  });

  const variableTarget = user.variableTarget ?? 0;

  return baseAnnualized + variableTarget;
};
